// extracted by mini-css-extract-plugin
export default {"container":"fp-z","ratingLayout":"gp-z","ratingLabel":"hp-z","nonInteractiveRatingLabel":"ip-z"};